module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-dialog', {
    attrs: {
      "dialog-style": {
        'background-color': 'transparent',
        'z-index': 4999
      },
      "mask-transition": _vm.maskTransition,
      "dialog-transition": _vm.dialogTransition
    },
    on: {
      "on-hide": function($event) {
        return _vm.$emit('on-hide')
      },
      "on-show": function($event) {
        return _vm.$emit('on-show')
      }
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    staticClass: "alert-notice-container"
  }, [_c('img', {
    staticClass: "header-img",
    attrs: {
      "src": require("../../../assets/alert-header.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "close-icon-container",
    on: {
      "click": _vm.closeBtnClick
    }
  }, [_c('icon', {
    staticClass: "close-icon",
    attrs: {
      "className": "icon",
      "symbol": "close-icon"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.noticeInfo.type === '3'),
      expression: "noticeInfo.type === '3'"
    }],
    staticClass: "middle-content",
    attrs: {
      "id": "middle-content"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.noticeInfo.type === '4'),
      expression: "noticeInfo.type === '4'"
    }],
    staticClass: "middle-content-iframe"
  }, [_c('spinner', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loadingFinish),
      expression: "!loadingFinish"
    }],
    staticClass: "loading-spinner",
    attrs: {
      "type": "ios",
      "size": '40px'
    }
  }), _vm._v(" "), _c('iframe', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadingFinish),
      expression: "loadingFinish"
    }],
    staticClass: "my-iframe",
    attrs: {
      "id": "notice-view-iframe",
      "frameborder": "0",
      "width": "100%",
      "height": "100%"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "button-container"
  }, [_c('button', {
    on: {
      "click": _vm.sureBtnClick
    }
  }, [_vm._v("确定")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a981e4c8!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/common/xy-notice-view.vue
// module id = 412
// module chunks = 36